// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1Rtmo","content":"Consent_content__SfcWS","footer":"Consent_footer__1ykbE"};